import { Spaces } from '@/features/space'

function Rooms() {
  return (
    <main className="flex flex-col pr-5 pb-6 max-h-full">
      <Spaces />
    </main>
  )
}

export default Rooms
